import { create } from "zustand"

type PersonalDataStore = {
  username?: string
  password?: string
  setUsername: (username: string) => void
  setPassword: (password: string) => void
}

const usePersonalDataStore = create<PersonalDataStore>((set) => ({
  username: undefined,
  password: undefined,
  setUsername: (username: string) => set({ username }),
  setPassword: (password: string) => set({ password }),
}))

export { usePersonalDataStore }
